import type { WateringInfo } from '../../types/careExpanded';

interface WateringSectionProps {
  watering: WateringInfo;
}

export function WateringSection({ watering }: WateringSectionProps) {
  return (
    <div className="space-y-4">
      {/* Method and frequency */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Method
          </dt>
          <dd className="mt-1 text-sm text-editorial-black font-medium">{watering.method}</dd>
        </div>
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Frequency
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{watering.frequency}</dd>
        </div>
      </div>

      {/* Dryness test */}
      {watering.drynessTest && (
        <div className="p-3 rounded-lg bg-blue-500/5 border border-blue-500/10">
          <dt className="text-xs font-medium uppercase tracking-wide text-blue-600">
            How to Check
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{watering.drynessTest}</dd>
        </div>
      )}

      {/* Signs of under/overwatering */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="p-3 rounded-lg bg-amber-500/5 border border-amber-500/10">
          <dt className="text-xs font-medium uppercase tracking-wide text-amber-600">
            Underwatered Signs
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{watering.signs.underwatered}</dd>
        </div>
        <div className="p-3 rounded-lg bg-red-500/5 border border-red-500/10">
          <dt className="text-xs font-medium uppercase tracking-wide text-red-600">
            Overwatered Signs
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{watering.signs.overwatered}</dd>
        </div>
      </div>

      {/* Water quality notes */}
      {watering.qualityNotes && (
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Water Quality
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{watering.qualityNotes}</dd>
        </div>
      )}
    </div>
  );
}
